<div class="relative w-full min-h-[calc(100vh-220px)] flex flex-col">
  <!-- Page title -->
  <div class="mb-4">
    <h1 class="text-2xl font-semibold text-black dark:text-white">
      All Transactions
    </h1>
  </div>

  <!-- Kendo containers -->
  <div kendoWindowContainer></div>
  <div kendoDialogContainer></div>

  <div class="mb-4 card" #searchCard>
    <div
      class="flex items-center justify-between cursor-pointer cPard-header"
      [class.border-b-0]="!isSearchExpanded"
      (click)="isSearchExpanded = !isSearchExpanded"
    >
      <h3 class="text-black card-title dark:text-white text-left">&nbsp;&nbsp;Search Details</h3>
      <div class="flex items-center">
        <button
          look="flat"
          class="flex items-center justify-center p-1 rounded-lg hover:bg-gray-500/10"
        >
          <ng-icon
            name="heroChevronDown"
            class="transition duration-200"
            [class.rotate-180]="isSearchExpanded"
          ></ng-icon>
        </button>
      </div>
    </div>
    @if (isSearchExpanded) {
    <div class="card-body">
      <form
        class="grid grid-cols-1 text-black k-form sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-2 dark:text-white"
        [formGroup]="searchForm"
        (ngSubmit)="onSubmit()"
      >
        <div class="flex items-center gap-2">
          <kendo-label
            class="w-32 text-black dark:text-white"
            text="Transaction Id:"
          ></kendo-label>
          <input
            kendoTextBox
            type="number"
            formControlName="blotterId"
            style="width: 250px"
          />
          <button
            *ngIf="searchForm.get('blotterId')?.value"
            kendoButton
            fillMode="flat"
            themeColor="error"
            type="button"
            (click)="clearFilter('blotterId')"
            title="Clear Transaction Id"
            class="p-1"
          >
            <span class="k-icon k-i-close"></span>
          </button>
        </div>

        <!-- Account Name -->
        <div class="flex items-center gap-2">
          <kendo-label
            class="w-32 text-black dark:text-white"
            text="Account Name:"
          ></kendo-label>
          <input
            kendoTextBox
            formControlName="accountName"
            style="width: 250px"
          />
          <button
            *ngIf="searchForm.get('accountName')?.value"
            kendoButton
            fillMode="flat"
            themeColor="error"
            type="button"
            (click)="clearFilter('accountName')"
            title="Clear Account Name"
            class="p-1"
          >
            <span class="k-icon k-i-close"></span>
          </button>
        </div>

        <!-- Account Number -->
        <div class="flex items-center gap-2">
          <kendo-label
            class="w-32 text-black dark:text-white"
            text="Account Number:"
          ></kendo-label>
          <input
            kendoTextBox
            formControlName="accountNumber"
            style="width: 250px"
          />
          <button
            *ngIf="searchForm.get('accountNumber')?.value"
            kendoButton
            fillMode="flat"
            themeColor="error"
            type="button"
            (click)="clearFilter('accountNumber')"
            title="Clear Account Number"
            class="p-1"
          >
            <span class="k-icon k-i-close"></span>
          </button>
        </div>

        <div class="flex items-center gap-2">
          <kendo-label
            class="w-32 text-black dark:text-white"
            text="Client:"
          ></kendo-label>
          <input
            kendoTextBox
            formControlName="clientName"
            style="width: 250px"
          />
          <button
            *ngIf="searchForm.get('clientName')?.value"
            kendoButton
            fillMode="flat"
            themeColor="error"
            type="button"
            (click)="clearFilter('clientName')"
            title="Clear Client Name"
            class="p-1"
          >
            <span class="k-icon k-i-close"></span>
          </button>
        </div>

        <!-- Branch -->
        <div *ngIf="branches" class="flex items-center gap-2">
          <kendo-label
            class="w-32 text-black dark:text-white"
            text="Branch:"
          ></kendo-label>
          <kendo-dropdownlist
            [data]="branches"
            formControlName="branchNumber"
            [defaultItem]="defaultBranchItem"
            (selectionChange)="branchChange($event)"
            style="width: 250px"
          ></kendo-dropdownlist>
          <button
            *ngIf="searchForm.get('branchNumber')?.value"
            kendoButton
            fillMode="flat"
            themeColor="error"
            type="button"
            (click)="clearFilter('branchNumber')"
            title="Clear Branch Number"
            class="p-1"
          >
            <span class="k-icon k-i-close"></span>
          </button>
        </div>

        <!-- Rep -->
        <div *ngIf="reps" class="flex items-center gap-2">
          <kendo-label
            class="w-32 text-black dark:text-white"
            text="Rep:"
          ></kendo-label>
          <kendo-dropdownlist
            [data]="filteredReps"
            textField="fullName"
            valueField="repId"
            [defaultItem]="defaultRepItem"
            formControlName="repId"
            (selectionChange)="repChange($event)"
            style="width: 250px"
          ></kendo-dropdownlist>
          <button
            kendoButton
            fillMode="flat"
            themeColor="error"
            type="button"
            (click)="clearFilter('repId')"
            title="Clear Rep"
            class="p-1"
          >
            <span class="k-icon k-i-close"></span>
          </button>
        </div>

        <!-- Rep Code, Status, and Approval date range on one row -->
        <div class="col-span-1 sm:col-span-2 lg:col-span-3">
          <p class="mb-1 text-xs text-black dark:text-white">
            * The date range is controlled by the number of days selected from
            the User Preferences page
          </p>
          <div class="flex flex-wrap items-center gap-x-6 gap-y-2">
            <!-- Rep Code -->
            <div *ngIf="reps" class="flex items-center gap-2">
              <kendo-label
                class="w-32 text-black dark:text-white"
                text="Rep Code:"
              ></kendo-label>
              <kendo-dropdownlist
                [data]="repCodeList"
                textField="repCode"
                valueField="repCode"
                [valuePrimitive]="true"
                formControlName="repCode"
                [defaultItem]="defaultRepCode"
                (selectionChange)="repCodeChange($event)"
                style="width: 250px"
              ></kendo-dropdownlist>
              <button
                *ngIf="searchForm.get('repCode')?.value"
                kendoButton
                fillMode="flat"
                themeColor="error"
                type="button"
                (click)="clearFilter('repCode')"
                title="Clear Rep Code"
                class="p-1"
              >
                <span class="k-icon k-i-close"></span>
              </button>
            </div>

            <!-- Status -->
            <div *ngIf="statuses" class="flex items-center gap-2">
              <kendo-label
                class="w-32 text-black dark:text-white"
                text="Status:"
              ></kendo-label>
              <kendo-dropdownlist
                [data]="statuses"
                [defaultItem]="defaultStatusItem"
                textField="statusTypeDesc"
                valueField="statusTypeId"
                [valuePrimitive]="true"
                formControlName="statusTypeId"
                (valueChange)="saveSessionFilters()"
                style="width: 250px"
              ></kendo-dropdownlist>
            </div>

            <!-- Approval Begin Date -->
            <div class="flex items-center gap-2 shrink-0">
              <label
                class="text-black form-label dark:text-white whitespace-nowrap"
                >Approval Begin Date:</label
              >
              <kendo-datepicker
                id="dpApprovalDateFrom"
                formControlName="approvalStartDate"
                [format]="'MM/dd/yyyy'"
                [disabled]="false"
                class="shrink-0"
                style="width: 200px; min-width: 200px"
              >
              </kendo-datepicker>
            </div>

            <!-- Approval End Date -->
            <div class="flex items-center gap-2 shrink-0">
              <label
                class="text-black form-label dark:text-white whitespace-nowrap"
                >Approval End Date:</label
              >
              <kendo-datepicker
                id="dpApprovalDateTo"
                formControlName="approvalEndDate"
                [format]="'MM/dd/yyyy'"
                [disabled]="false"
                class="shrink-0"
                style="width: 200px; min-width: 200px"
              >
              </kendo-datepicker>
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div
          class="flex justify-start col-span-1 gap-3 mt-2 sm:col-span-2 lg:col-span-3"
        >
          <button
            kendoButton
            fillMode="outline"
            themeColor="error"
            type="button"
            (click)="clearFields()"
          >
            Clear
          </button>
          <button
            kendoButton
            fillMode="outline"
            themeColor="primary"
            type="button"
            (click)="resetFields()"
          >
            Reset
          </button>
          <button kendoButton themeColor="primary" type="submit">Search</button>
        </div>
      </form>
    </div>
    }
  </div>

  <!-- Shown while the full result downloads behind the first-page preview.
       Matters most with a filter active: the grid filters client-side, so
       results are incomplete until this clears. -->
  <div
    *ngIf="loadingAll"
    class="flex items-center gap-2 mx-4 mb-2 px-3 py-2 rounded border border-amber-300 bg-amber-50 text-amber-800"
    style="font-size: small"
  >
    <span class="k-icon k-i-loading"></span>
    <span *ngIf="hasActiveFilter">
      Searching the full transaction list - still loading, so results may be
      incomplete for a moment.
    </span>
    <span *ngIf="!hasActiveFilter">
      Showing the first {{ previewRowCount }} transactions - loading the full list...
    </span>
  </div>

  <!-- gridHeight: the grid shrinks to fit a short page of rows, and stops above
       the footer (scrolling inside the grid, pager visible) for a long one. -->
  <div class="w-full overflow-hidden" [style.height.px]="gridHeight" #gridContainer>
      <kendo-grid
        [style.height.px]="gridHeight"
        #grid
        [kendoGridBinding]="searchResults"
        [pageable]="true"
        [pageSize]="pageSize"
        (pageChange)="onPageChange($event)"
        [groupable]="true"
        [sortable]="true"
        [sort]="sort"
        (sortChange)="onSortChange($event)"
        (dataBound)="onGridDataBound()"
        [filterable]="'menu'"
        [resizable]="true"
        [rowClass]="rowCallback"
        [loading]="loading"
        class="w-full"
      >
        <ng-template kendoGridToolbarTemplate>
          <button
            type="button"
            kendoGridExcelCommand
            [svgIcon]="fileExcelIcon"
            [disabled]="loadingAll"
          >
            Export to Excel
          </button>
        </ng-template>

        <!-- Dynamic Columns -->
        <kendo-grid-column
          *ngFor="let column of columns"
          [field]="column.field"
          [title]="column.title"
          [width]="column.width"
          [filterable]="column.filterable"
          [sortable]="column.sortable !== false"
          [hidden]="column.hidden"
          [format]="column.format"
          [ngSwitch]="column.template"
        >
          <ng-template
            *ngSwitchCase="'bookmark'"
            kendoGridCellTemplate
            let-dataItem
          >
            <span>
              <a
                (click)="updateBookmark(dataItem)"
                [ngClass]="
                  dataItem.bookm === null ? 'black-color' : 'blue-color'
                "
              >
                <ng-icon name="heroBookmarkSolid"></ng-icon>
              </a>
            </span>
          </ng-template>
          <ng-template
            *ngSwitchCase="'viewAccount'"
            kendoGridCellTemplate
            let-dataItem
          >
            <div
              class="selectable"
              title="View/Edit Account"
              (click)="viewClientInfo(dataItem.clientId)"
            >
              {{ dataItem.accountName }}
            </div>
          </ng-template>
          <ng-template
            *ngSwitchCase="'date'"
            kendoGridCellTemplate
            let-dataItem
          >
            {{ dataItem[column.field] | date : 'MM/dd/yyyy' }}
          </ng-template>
          <ng-template
            *ngSwitchCase="'boolean'"
            kendoGridCellTemplate
            let-dataItem
          >
            {{ dataItem[column.field] ? 'Yes' : 'No' }}
          </ng-template>
          <ng-template
            *ngSwitchCase="'statusType'"
            kendoGridCellTemplate
            let-dataItem
          >
            <span *ngIf="dataItem.statusTypeId > -2">{{
              dataItem.statusTypeDesc
            }}</span>
            <span *ngIf="dataItem.statusTypeId === -2">
              <kendo-dropdownlist
                [data]="dropdownStatusLight"
                [valuePrimitive]="true"
                size="small"
                [(ngModel)]="dataItem.statusTypeId"
                textField="text"
                valueField="value"
                [popupSettings]="{ width: 250, height: 150 }"
                style="width: 100%; font-size: 10px !important;"
              ></kendo-dropdownlist>
            </span>
          </ng-template>
        </kendo-grid-column>

        <!-- Static Columns with Icons -->
        <kendo-grid-column [width]="42" [hidden]="hidebyRole" [sticky]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div *ngIf="dataItem.showReviewTransaction">
              <a
                class="icon-btn"
                title="Review Summary"
                (click)="
                  ReviewTransactionsview(
                    dataItem.blotterId,
                    dataItem.clientId,
                    dataItem.repId,
                    dataItem.clientName,
                    dataItem.statusTypeId,
                    dataItem.transactionTypeId,
                    dataItem.productTypeId,
                    dataItem.showReviewTransaction,
                    dataItem.showAccountReview,
                    dataItem.state,
                    dataItem.repCodeId
                  )
                "
              >
                <ng-icon name="heroEye"></ng-icon>
              </a>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="42" [hidden]="hidebyRole" [sticky]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div
              *ngIf="
                dataItem.accountFormReviewCount > 0 &&
                dataItem.statusTypeId > -2 &&
                dataItem.newAccountForm === 'On File' &&
                dataItem.blotterId > 0
              "
            >
              <a
                class="icon-btn"
                (click)="openForm(dataItem)"
                title="Account Form Receipt"
              >
                <ng-icon name="heroMagnifyingGlass"></ng-icon>
              </a>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          [filterable]="false"
          [width]="42"
          [hidden]="hidebyRole"
          [sticky]="true"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <div *ngIf="dataItem.showAccountReview">
              <a
                class="icon-btn"
                title="Account Form Review"
                (click)="
                  ReviewAccountTransactionsview(
                    dataItem.blotterId,
                    dataItem.clientId,
                    dataItem.repId,
                    dataItem.clientName,
                    dataItem.statusTypeId,
                    dataItem.transactionTypeId,
                    dataItem.productTypeId,
                    dataItem.showReviewTransaction,
                    dataItem.showAccountReview,
                    dataItem.repCodeId
                  )
                "
              >
                <ng-icon name="heroArchiveBox"></ng-icon>
              </a>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          title=""
          [filterable]="false"
          [width]="42"
          [hidden]="hidebyRole"
          [sticky]="true"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              class="icon-btn"
              title="Edit Transaction"
              (click)="
                 EditTransactions(
                  dataItem.blotterId,
                  dataItem.clientId,
                  dataItem.repId,
                   dataItem.repCodeId,
                  dataItem.clientName,
                  dataItem.statusTypeId,
                  dataItem.transactionTypeId,
                  dataItem.productTypeId,
                  dataItem.showReviewTransaction,
                  dataItem.showAccountReview,
                  dataItem.state
                )
              "
            >
              <ng-icon name="heroPencilSquare"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="42" #lastColumn [sticky]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              class="icon-btn"
              title="View Files"
              (click)="
                viewFiles(
                  dataItem.repId,
                  dataItem.clientName,
                  dataItem.blotterId,
                  dataItem.clientId,
                  'blotterId'
                )
              "
            >
              <ng-icon name="heroFolderOpen"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="42" [filterable]="false" [sticky]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              class="icon-btn"
              title="Approval Notice"
              *ngIf="dataItem.accountFormReviewCount != 0"
              [ngClass]="{
                'opacity-50 cursor-not-allowed pointer-events-none':
                  !isApproved(dataItem)
              }"
              [attr.aria-disabled]="!isApproved(dataItem)"
              (click)="isApproved(dataItem) && openAccountFormReport(dataItem)"
            >
              <ng-icon name="heroDocument"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-excel
          [fetchData]="allData"
          fileName="Transactions.xlsx"
        ></kendo-grid-excel>
      </kendo-grid>
  </div>

  <kendo-window
    title="View Client"
    animate="animates"
    (stateChange)="onStateChange($event)"
    *ngIf="viewClientOpen"
    (close)="resetSelected()"
    [top]="50"
    [left]="250"
    [width]="850"
  >
    <gd-clienttrans
      [ngClass]="{ max: enlarge === 'maximized', def: enlarge === 'default' }"
      [outputBlotterId]="$any(selectedBlotterId)"
    ></gd-clienttrans>
  </kendo-window>

  <kendo-dialog
    animate="animates"
    (close)="onDialogReciptClose()"
    *ngIf="openAccountReadOnly"
    [minWidth]="250"
    [width]="550"
  >
    <kendo-dialog-titlebar>
      <div style="font-size: 18px; line-height: 1.3em">
        <ng-icon name="heroPrinter"></ng-icon> Print Receipt
      </div>
    </kendo-dialog-titlebar>
    <div class="card">
      <gd-pdfsavior
        [RepNamInfo]="RepNamInfo"
        [blotterId]="blotterComment"
      ></gd-pdfsavior>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="onDialogReciptClose()" style="width: 100%">
        Close Window
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <kendo-dialog
    animate="animates"
    (close)="resetSelected()"
    *ngIf="formReportOpen"
    [minWidth]="250"
    [width]="550"
  >
    <kendo-dialog-titlebar>
      <div style="font-size: 18px; line-height: 1.3em">
        <ng-icon name="heroPrinter"></ng-icon> Transaction Approval Details
      </div>
    </kendo-dialog-titlebar>
    <div class="card">
      <gd-accountreport
        [RepNamInfo]="selectedData"
        [blotterId]="selectedBlotterIdNum"
      ></gd-accountreport>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="resetSelected()" style="width: 100%">
        Close Window
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>
